import { render } from "./SexForm.vue?vue&type=template&id=9d61c932&scoped=true"
import script from "./SexForm.vue?vue&type=script&lang=js"
export * from "./SexForm.vue?vue&type=script&lang=js"

import "./SexForm.vue?vue&type=style&index=0&id=9d61c932&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d61c932"]])

export default __exports__